import React from "react";
import { NavLink } from "react-router-dom";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { RiContractFill } from "react-icons/ri";




const LeftbarAdmin = ({ handleSidebarClose, customClass }) => {
  return (
    <>
      <aside className={`sidenav navbar navbar-vertical navbar-expand-xs fixed-left  ${customClass}`}>
        <div className="sidenav-header">
          <div className="navbar-brand m-0">
            <img
              src="/img/logo.png"
              className="navbar-brand-img h-100 w-13"
              alt="Logo"
              style={{ marginRight: "8px" }}
            />
          </div>
          <div>

          </div>

        </div>
        <div className="collapse navbar-collapse  w-auto">
          <ul className="navbar-nav">
            <li className="nav-item" onClick={handleSidebarClose}>
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                to={"/dashboard"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-th-large " />
                </div>
                <span className="nav-link-text ms-1">Dashboard</span>
              </NavLink>
            </li>
            {/* <li className="nav-item" onClick={handleSidebarClose}>
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                to={"/lenderlist"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  
                  <FaList />
                </div>
                <span className="nav-link-text ms-1">Lender</span>
              </NavLink>
            </li> */}

            {/* <li className="nav-item" onClick={handleSidebarClose}>
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                to={"/borrowerList"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-user" />
                </div>
                <span className="nav-link-text ms-1">Borrower</span>
              </NavLink>
            </li> */}
            {/* <li className="nav-item" onClick={handleSidebarClose}>
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                to={"/projects"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <GoProjectSymlink />
                </div>
                <span className="nav-link-text ms-1">Projects</span>
              </NavLink>
            </li> */}
            {/* <li className="nav-item" onClick={handleSidebarClose}>
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                to={"/projectfund-status"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <RiFundsBoxFill />
                </div>
                <span className="nav-link-text ms-1">Project-fund Status</span>
              </NavLink>
            </li> */}
            <li className="nav-item" onClick={handleSidebarClose}>
              <NavLink
                className="nav-link  "
                activeClassName="active"
                to={"/create-contract"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <RiContractFill />
                </div>
                <span className="nav-link-text ms-1">Create Contract</span>
              </NavLink>
            </li>
            <li className="nav-item" onClick={handleSidebarClose}>
              <NavLink
                className="nav-link  "
                activeClassName="active"
                to={"/request-contract"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <RiContractFill />
                </div>
                <span className="nav-link-text ms-1">View Contract</span>
              </NavLink>
            </li>

            <li className="nav-item" onClick={handleSidebarClose}>
              <NavLink
                className="nav-link  "
                activeClassName="active"
                to={"/assign-template"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <RiContractFill />
                </div>
                <span className="nav-link-text ms-1">AssignTemplate User</span>
              </NavLink>
            </li>
            {/* <li className="nav-item" onClick={handleSidebarClose}>
              <NavLink
                className="nav-link  "
                activeClassName=" active"
                to={"/update-password"}
              >
                <div className="icon icon-shape icon-sm shadow border-radius-md bg-white text-center me-2 d-flex align-items-center justify-content-center">
                  <i className="fas fa-lock" />
                </div>
                <span className="nav-link-text ms-1">Update Password</span>
              </NavLink>
            </li> */}


          </ul>
        </div>
      </aside>
    </>
  );
};


export default LeftbarAdmin;